export default {
    root: ({ props, context, parent, instance }) => ({
        class: [
            'relative  no-underline',

            // Alignments
            'items-center inline-flex text-center align-bottom justify-center',
            { 'flex-col': (props.iconPos === 'top' || props.iconPos === 'bottom') && props.label },

            // Sizes & Spacing
            'leading-[normal]',
            {
                'px-6 py-2 h-12': props.size === null,
                'text-sm py-1 px-4 h-8': props.size === 'small',
                'text-lg py-3 px-8 h-14': props.size === 'large',
            },
            { 'gap-2': props.label !== null },
            {
                'w-10 px-0 py-2': props.label == null && props.icon !== null,
            },
            {
                'w-10 px-0 gap-0': instance.hasIcon && !props.label && !props.badge,
                'rounded-[50%] h-10 [&>[data-pc-section=label]]:w-0 [&>[data-pc-section=label]]:invisible': instance.hasIcon && !props.label && !props.badge && props.rounded,
            },

            // Shapes
            { 'shadow-lg': props.raised },
            { rounded: !props.rounded, 'rounded-full': props.rounded },
            { 'rounded-none first:rounded-l-md last:rounded-r-md': parent.instance.$name == 'InputGroup' },

            // Link Button
            { /* tw */ 'text-black bg-transparent-full border-transparent-full': props.link },

            // Plain Button
            { /* tw */ 'text-white bg-gray-500 border border-gray-500': props.plain && !props.outlined && !props.text },
            // Plain Text Button
            { /* tw */ 'text-black': props.plain && props.text },
            // Plain Outlined Button
            { /* tw */ 'text-black border border-gray-500': props.plain && props.outlined },

            // Text Button
            { /* tw */ 'bg-transparent-full border-transparent-full': props.text && !props.plain },

            // Outlined Button
            { /* tw */ 'bg-transparent-full border': props.outlined && !props.plain },

            // --- Severity Buttons ---

            // Primary Button
            {
                'text-gray-05': !props.link && props.severity === null && !props.text && !props.outlined && !props.plain,
                /* tw */ 'bg-black': !props.link && props.severity === null && !props.text && !props.outlined && !props.plain,
                /* tw */ 'border border-black': !props.link && props.severity === null && !props.text && !props.outlined && !props.plain,
            },
            // Primary Text Button
            {
                /* tw */ 'text-black': props.text && props.severity === null && !props.plain,
            },
            // Primary Outlined Button
            {
                /* tw */ 'text-black border border-black': props.outlined && props.severity === null && !props.plain,
            },

            // Secondary Button
            {
                /* tw */ 'text-gray-700': props.severity === 'secondary' && !props.text && !props.outlined && !props.plain,
                /* tw */ 'bg-gray-05': props.severity === 'secondary' && !props.text && !props.outlined && !props.plain,
                /* tw */ 'border border-transparent-dark-20': props.severity === 'secondary' && !props.text && !props.outlined && !props.plain,
            },
            // Secondary Text Button
            {
                /* tw */ 'text-gray-700 dark:text-surface-300': props.text && props.severity === 'secondary' && !props.plain,
            },
            // Secondary Outlined Button
            {
                /* tw */ 'text-gray-700 border border-transparent-dark-20 hover:bg-gray-50': props.outlined && props.severity === 'secondary' && !props.plain,
            },

            // Success Button
            {
                /* tw */ 'text-white dark:text-green-900': props.severity === 'success' && !props.text && !props.outlined && !props.plain,
                /* tw */ 'bg-green-pure dark:bg-green-400': props.severity === 'success' && !props.text && !props.outlined && !props.plain,
                /* tw */ 'border border-green-pure dark:border-green-400': props.severity === 'success' && !props.text && !props.outlined && !props.plain,
            },
            // Success Text Button
            {
                /* tw */ 'text-green-pure dark:text-green-400': props.text && props.severity === 'success' && !props.plain,
            },
            // Success Outlined Button
            {
                /* tw */ 'text-green-pure border border-green-pure hover:bg-green-300/10': props.outlined && props.severity === 'success' && !props.plain,
            },

            // Info Button
            {
                /* tw */ 'text-white dark:text-surface-900': props.severity === 'info' && !props.text && !props.outlined && !props.plain,
                /* tw */ 'bg-blue-500 dark:bg-blue-400': props.severity === 'info' && !props.text && !props.outlined && !props.plain,
                /* tw */ 'border border-blue-500 dark:border-blue-400': props.severity === 'info' && !props.text && !props.outlined && !props.plain,
            },
            // Info Text Button
            { 'text-blue-500 dark:text-blue-400': props.text && props.severity === 'info' && !props.plain },
            // Info Outlined Button
            {
                'text-blue-500 border border-blue-500 hover:bg-blue-300/10 ': props.outlined && props.severity === 'info' && !props.plain,
            },

            // Warning Button
            {
                'text-white dark:text-surface-900': props.severity === 'warn' && !props.text && !props.outlined && !props.plain,
                'bg-orange-500 dark:bg-orange-400': props.severity === 'warn' && !props.text && !props.outlined && !props.plain,
                'border border-orange-500 dark:border-orange-400': props.severity === 'warn' && !props.text && !props.outlined && !props.plain,
            },
            // Warning Text Button
            { 'text-orange-500 dark:text-orange-400': props.text && props.severity === 'warn' && !props.plain },
            // Warning Outlined Button
            {
                'text-orange-500 border border-orange-500 hover:bg-orange-300/10': props.outlined && props.severity === 'warn' && !props.plain,
            },

            // Help Button
            {
                'text-white dark:text-surface-900': props.severity === 'help' && !props.text && !props.outlined && !props.plain,
                'bg-purple-500 dark:bg-purple-400': props.severity === 'help' && !props.text && !props.outlined && !props.plain,
                'border border-purple-500 dark:border-purple-400': props.severity === 'help' && !props.text && !props.outlined && !props.plain,
            },
            // Help Text Button
            { 'text-purple-500 dark:text-purple-400': props.text && props.severity === 'help' && !props.plain },
            // Help Outlined Button
            {
                'text-purple-500 border border-purple-500 hover:bg-purple-300/10': props.outlined && props.severity === 'help' && !props.plain,
            },

            // Danger Button
            {
                /* tw */ 'text-white': props.severity === 'danger' && !props.text && !props.outlined && !props.plain,
                /* tw */ 'bg-red-pure': props.severity === 'danger' && !props.text && !props.outlined && !props.plain,
                /* tw */ 'border border-red-pure': props.severity === 'danger' && !props.text && !props.outlined && !props.plain,
            },
            // Danger Text Button
            {
                /* tw */ 'text-red-pure': props.text && props.severity === 'danger' && !props.plain,
            },
            // Danger Outlined Button
            {
                /* tw */ 'text-red-pure border border-red-pure hover:bg-red-300/10': props.outlined && props.severity === 'danger' && !props.plain,
            },

            // Contrast Button
            {
                'text-white dark:text-surface-900': props.severity === 'contrast' && !props.text && !props.outlined && !props.plain,
                'bg-surface-900 dark:bg-surface-0': props.severity === 'contrast' && !props.text && !props.outlined && !props.plain,
                'border border-surface-900 dark:border-surface-0': props.severity === 'contrast' && !props.text && !props.outlined && !props.plain,
            },
            // Contrast Text Button
            { 'text-surface-900 dark:text-surface-0': props.text && props.severity === 'contrast' && !props.plain },
            // Contrast Outlined Button
            {
                'text-surface-900 dark:text-surface-0 border border-surface-900 dark:border-surface-0': props.outlined && props.severity === 'contrast' && !props.plain,
            },

            // --- Severity Button States ---
            'focus:outline-none focus:outline-offset-0 focus:ring-1',

            // Link
            { /* tw */ 'focus:ring-black': props.link },

            // Plain
            { /* tw */ 'hover:bg-gray-600 hover:border-gray-600': props.plain && !props.outlined && !props.text },
            // Text & Outlined Button
            { /* tw */ 'hover:bg-surface-300/10': props.plain && (props.text || props.outlined) },

            // Primary
            { /* tw */ 'hover:bg-gray-700 hover:border-gray-700': !props.link && props.severity === null && !props.text && !props.outlined && !props.plain },
            { /* tw */ 'focus:ring-black': props.severity === null },
            // Text & Outlined Button
            { /* tw */ 'hover:bg-gray-300/10': (props.text || props.outlined) && props.severity === null && !props.plain },

            // Secondary
            { /* tw */ 'hover:bg-gray-50': props.severity === 'secondary' && !props.text && !props.outlined && !props.plain },
            { /* tw */ 'focus:ring-surface-500 dark:focus:ring-surface-400': props.severity === 'secondary' },
            // Text & Outlined Button
            { 'hover:bg-gray-50': (props.text || props.outlined) && props.severity === 'secondary' && !props.plain },

            // Success
            {
                'hover:bg-green-600 dark:hover:bg-green-300 hover:border-green-600 dark:hover:border-green-300':
                    props.severity === 'success' && !props.text && !props.outlined && !props.plain,
            },
            { 'focus:ring-green-500 dark:focus:ring-green-400': props.severity === 'success' },
            // Text & Outlined Button
            { 'hover:bg-green-300/10': (props.text || props.outlined) && props.severity === 'success' && !props.plain },

            // Info
            {
                'hover:bg-blue-600 dark:hover:bg-blue-300 hover:border-blue-600 dark:hover:border-blue-300':
                    props.severity === 'info' && !props.text && !props.outlined && !props.plain,
            },
            { 'focus:ring-blue-500 dark:focus:ring-blue-400': props.severity === 'info' },
            // Text & Outlined Button
            { 'hover:bg-blue-300/10': (props.text || props.outlined) && props.severity === 'info' && !props.plain },

            // Warning
            {
                'hover:bg-orange-600 dark:hover:bg-orange-300 hover:border-orange-600 dark:hover:border-orange-300':
                    props.severity === 'warn' && !props.text && !props.outlined && !props.plain,
            },
            { 'focus:ring-orange-500 dark:focus:ring-orange-400': props.severity === 'warn' },
            // Text & Outlined Button
            { 'hover:bg-orange-300/10': (props.text || props.outlined) && props.severity === 'warn' && !props.plain },

            // Help
            {
                'hover:bg-purple-600 dark:hover:bg-purple-300 hover:border-purple-600 dark:hover:border-purple-300':
                    props.severity === 'help' && !props.text && !props.outlined && !props.plain,
            },
            { 'focus:ring-purple-500 dark:focus:ring-purple-400': props.severity === 'help' },
            // Text & Outlined Button
            { 'hover:bg-purple-300/10': (props.text || props.outlined) && props.severity === 'help' && !props.plain },

            // Danger
            {
                'hover:bg-feedback-danger_medium hover:bg-feedback-danger_medium': props.severity === 'danger' && !props.text && !props.outlined && !props.plain,
            },
            { 'focus:ring-feedback-danger_medium': props.severity === 'danger' },
            // Text & Outlined Button
            { 'hover:bg-red-300/10': (props.text || props.outlined) && props.severity === 'danger' && !props.plain },

            // Contrast
            {
                'hover:bg-surface-800 dark:hover:bg-surface-100 hover:border-surface-800 dark:hover:border-surface-100':
                    props.severity === 'contrast' && !props.text && !props.outlined && !props.plain,
            },
            { 'focus:ring-surface-500 dark:focus:ring-surface-400': props.severity === 'contrast' },
            // Text & Outlined Button
            {
                'hover:bg-surface-900/10 dark:hover:bg-[rgba(255,255,255,0.03)]': (props.text || props.outlined) && props.severity === 'contrast' && !props.plain,
            },

            // Disabled
            { 'opacity-60 pointer-events-none cursor-default': context.disabled },

            // Transitions
            'transition duration-200 ease-in-out',

            // Misc
            'cursor-pointer overflow-hidden select-none',

            // Badge
            '[&>[data-pc-name=badge]]:min-w-4 [&>[data-pc-name=badge]]:h-4 [&>[data-pc-name=badge]]:leading-4',
        ],
    }),
    label: ({ props }) => ({
        class: [
            'font-medium',
            'leading-[1.6]',
            'text-nowrap',
            {
                'hover:underline': props.link,
            },
            { 'invisible w-0': props.label == null },
        ],
    }),
    icon: ({ props }) => ({
        class: [
            'text-base leading-4',
            'mx-0',
            {
                'order-1': props.iconPos == 'right' && props.label != null,
                'order-2': props.iconPos == 'bottom' && props.label != null,
            },
        ],
    }),
    loadingIcon: ({ props }) => ({
        class: [
            'h-4 w-4',
            'mx-0',
            {
                'mr-2': props.iconPos == 'left' && props.label != null,
                'ml-2 order-1': props.iconPos == 'right' && props.label != null,
                'mb-2': props.iconPos == 'top' && props.label != null,
                'mt-2': props.iconPos == 'bottom' && props.label != null,
            },
            'animate-spin',
        ],
    }),
    badge: ({ props }) => ({
        class: [{ 'ml-2 w-4 h-4 leading-none flex items-center justify-center': props.badge }],
    }),
};
